module.exports = __webpack_public_path__ + "assets/img/pages/partners/sfwl-color.svg";